import type { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { cn } from '@/lib/cn';

interface CustomerEmptyStateProps {
  icon: IconDefinition;
  title: string;
  description?: string;
  className?: string;
  tone?: 'success' | 'neutral';
  action?: ReactNode;
}

export function CustomerEmptyState({
  icon,
  title,
  description,
  className = '',
  tone = 'success',
  action,
}: CustomerEmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center gap-2 px-4 py-8 text-center', className)}>
      <div
        className={cn(
          'flex h-12 w-12 items-center justify-center rounded-full',
          tone === 'success'
            ? 'bg-customer-success/10 text-customer-success-text'
            : 'bg-customer-text/[0.06] text-customer-text-secondary',
        )}
        aria-hidden="true"
      >
        <FontAwesomeIcon icon={icon} className="h-5 w-5" />
      </div>
      <p className="text-sm font-semibold text-customer-text">{title}</p>
      {description && (
        <p className="max-w-xs text-sm leading-5 text-customer-text-secondary">{description}</p>
      )}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
